import type { ProjectCompaniesSort } from '@/api/v4/projects.api';
import { colors } from '@/theme/colors';
import type { HeaderCellConfig } from '@/ui/table/table.types';

export const ProjectListingTableHeader: HeaderCellConfig<ProjectCompaniesSort>[] =
  [
    {
      columnKey: 'companyName',
      sortKey: 'companyName',
      padding: '21px 12px',
      bgColor: colors.basics.white,
    },
    {
      columnKey: 'tags',
      width: '300px',
      bgColor: colors.basics.white,
    },
    {
      columnKey: 'projects',
      width: '200px',
      bgColor: colors.basics.white,
    },
    {
      columnKey: 'yearFounded',
      width: '200px',
      sortKey: 'yearEstablished',
      bgColor: colors.basics.white,
    },
    {
      columnKey: 'fundingStage',
      width: '200px',
      sortKey: 'fundingStage',
      bgColor: colors.basics.white,
    },
    {
      columnKey: 'capitalRaised',
      width: '200px',
      sortKey: 'capitalRaised',
      bgColor: colors.basics.white,
    },
    {
      columnKey: 'lastModified',
      width: '200px',
      sortKey: 'createdDate',
      bgColor: colors.basics.white,
    },
    {
      columnKey: 'stage',
      padding: '21px 30px',
      width: '242px',
      sortKey: 'status',
      bgColor: colors.basics.white,
    },

    {
      columnKey: 'listingMenu',
      hideLabel: true,
    },
  ];
